<mat-card appearance="outlined">
    <mat-card-content>
        <h2>
            {{'businessTexts.requestForIdentificationByType' | translate}}
        </h2>
        <mat-tab-group class="col" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)" animationDuration="0ms">
            <!-- Signing history -->
            <mat-tab [disabled]="!hasIdentification">
                <ng-template mat-tab-label class="mat-mdc-tab-label-container">
                    <cqes-icon icon="done"></cqes-icon>
                    {{'businessTexts.identificationTable.eid' | translate}}
                </ng-template>
                <mat-card>
                    <div class="column-content">
                        <form [formGroup]="identificatorForm" (ngSubmit)="onSubmitIdentificatorForm()">
                            <div class="row-content">


                            <div class="cursor-not-allowed select-flex">
                                <mat-form-field class="disabled-select">
                                    <mat-select placeholder="{{'businessTexts.egn' | translate}}" formControlName="personalIdType">
                                        <mat-option *ngFor="let option of egnOptions" [value]="option">{{ 'businessTexts.' +
                                            option.toLowerCase() | translate}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            
                            <mat-form-field [matTooltip]="'businessTexts.identificatorTooltip' | translate" [matTooltipClass]="'tooltip-narrow'">
                                <mat-label>{{ 'businessTexts.identificator' | translate }} </mat-label>
                                <input matInput formControlName="personalId" type="text">
                                <mat-error *ngIf="identificatorForm.get('personalId')?.hasError('required') && identificatorForm.get('personalId')?.touched">
                                    {{ 'businessTexts.identifierRequired' | translate }}
                                </mat-error>
                            
                                <mat-error *ngIf="identificatorForm.get('personalId')?.hasError('pattern') && identificatorForm.get('personalId')?.touched">
                                    {{ 'businessTexts.Must10digits' | translate }}
                                </mat-error>
                            </mat-form-field>
                            
                            <mat-form-field [matTooltip]="'businessTexts.emailPhoneTooltip' | translate" [matTooltipClass]="'tooltip-narrow'">
                                <mat-label>{{ 'businessTexts.email' | translate }} </mat-label>
                                <input matInput formControlName="email" type="email">
                                <mat-error
                                    *ngIf="identificatorForm.get('email')?.hasError('email') || identificatorForm.get('email')?.hasError('pattern') || identificatorForm.get('phone')?.hasError('pattern')">
                                    {{'businessTexts.invalidEmail' | translate}}
                                </mat-error>
                            </mat-form-field>
                            
                            <mat-form-field [matTooltip]="'businessTexts.emailPhoneTooltip' | translate" [matTooltipClass]="'tooltip-narrow'">
                                <mat-label>{{ 'businessTexts.phone' | translate }} </mat-label>
                                <input matInput formControlName="phone" type="tel">
                                <mat-error *ngIf="identificatorForm.get('phone')?.hasError('required') && identificatorForm.get('phone')?.touched">
                                    {{'businessTexts.phoneRequired' | translate}}
                                </mat-error>
                                <mat-error *ngIf="identificatorForm.get('phone')?.hasError('pattern') && identificatorForm.get('phone')?.touched">
                                    {{'businessTexts.phoneValidatorError' | translate}}
                                </mat-error>
                                <mat-error *ngIf="identificatorForm.hasError('atLeastOneRequired')">
                                    {{'businessTexts.atLeastOneContactRequired' | translate}}
                                </mat-error>
                            </mat-form-field>
                            
                            <mat-form-field [matTooltip]="'businessTexts.reasonTooltip' | translate" [matTooltipClass]="'tooltip-narrow'">
                                <mat-label>{{ 'businessTexts.reason' | translate }} </mat-label>
                                <input matInput formControlName="identificationReason" type="text">
                                <mat-error *ngIf="identificatorForm.get('identificationReason')?.hasError('maxlength')" class="text-error-reason">
                                    {{'businessTexts.reasonValidatorError' | translate}}
                                </mat-error>
                            
                                <mat-error *ngIf="identificatorForm.get('identificationReason')?.hasError('required')">
                                    {{'businessTexts.reasonRequired' | translate }}
                                </mat-error>

                                <mat-error *ngIf="identificatorForm.get('identificationReason')?.hasError('pattern') && identificatorForm.get('identificationReason')?.touched">
                                    {{'businessTexts.reasonValidatorInvalidPattern' | translate}}
                                </mat-error>
                            </mat-form-field>
                            
                            <button mat-raised-button type="submit" [disabled]="identificatorForm.invalid || isSubmitting">{{'businessTexts.send' |
                                translate}}
                            </button>
                            </div>
                        </form>
                    </div>
                </mat-card>
            </mat-tab>

            <!-- Sent history -->
            <mat-tab [disabled]="!hasWebIdentification">
                <ng-template mat-tab-label>
                    <cqes-icon icon="done"></cqes-icon>
                    {{'businessTexts.identificationTable.webEIC' | translate}}
                </ng-template>
                <mat-card >
                  <cloud-web-dentification #webIdent></cloud-web-dentification>
                </mat-card>
            </mat-tab>           
        </mat-tab-group>
      </mat-card-content>
</mat-card>      
<!-- BT-1494 Comming from master 
<mat-card appearance="outlined">
    <mat-card-content>
        <h2>
            {{'businessTexts.requestForIdentification' | translate}}
        </h2>
        <div class="column-content">
            <form [formGroup]="identificatorForm" (ngSubmit)="onSubmitIdentificatorForm()">
                <div class="row-content">


                    <div class="cursor-not-allowed">
                        <mat-form-field class="disabled-select">
                            <mat-select placeholder="{{'businessTexts.egn' | translate}}"
                                formControlName="personalIdType">
                                <mat-option *ngFor="let option of egnOptions" [value]="option">{{ 'businessTexts.' +
                                    option.toLowerCase() | translate}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    
                    <mat-form-field [matTooltip]="'businessTexts.identificatorTooltip' | translate" [matTooltipClass]="'tooltip-narrow'">
                        <mat-label>{{ 'businessTexts.identificator' | translate }} </mat-label>
                        <input matInput formControlName="personalId" type="text">
                        <mat-error *ngIf="identificatorForm.get('personalId')?.hasError('required')">
                            {{ 'businessTexts.identifierRequired' | translate }}
                        </mat-error>
                    
                        <mat-error *ngIf="identificatorForm.get('personalId')?.hasError('pattern')">
                            {{ 'businessTexts.Must10digits' | translate }}
                        </mat-error>
                    </mat-form-field>
                    
                    <mat-form-field [matTooltip]="'businessTexts.emailPhoneTooltip' | translate" [matTooltipClass]="'tooltip-narrow'">
                        <mat-label>{{ 'businessTexts.email' | translate }} </mat-label>
                        <input matInput formControlName="email" type="email" >
                        <mat-error
                            *ngIf="identificatorForm.get('email')?.hasError('email') || identificatorForm.get('email')?.hasError('pattern') || identificatorForm.get('phone')?.hasError('pattern')">
                            {{'businessTexts.invalidEmail' | translate}}
                        </mat-error>
                    </mat-form-field>
                    
                    <mat-form-field [matTooltip]="'businessTexts.emailPhoneTooltip' | translate" [matTooltipClass]="'tooltip-narrow'">
                        <mat-label>{{ 'businessTexts.phone' | translate }} </mat-label>
                        <input matInput formControlName="phone" type="tel">
                        <mat-error *ngIf="identificatorForm.get('phone')?.hasError('pattern')" class="text-error-phone">
                            {{'businessTexts.phoneValidatorError' | translate}}
                        </mat-error>
                    </mat-form-field>
                    
                    <mat-form-field>
                        <mat-label>{{ 'businessTexts.reason' | translate }} </mat-label>
                        <input matInput formControlName="identificationReason" type="text">
                        <mat-error *ngIf="identificatorForm.get('identificationReason')?.hasError('maxLength')" class="text-error-reason">
                            {{'businessTexts.reasonValidatorError' | translate}}
                        </mat-error>

                        <mat-error *ngIf="identificatorForm.get('identificationReason')?.hasError('required')">
                            {{'businessTexts.identifierRequired' | translate }}
                        </mat-error>
                    </mat-form-field>
                    
                    <button mat-raised-button type="submit" [disabled]="identificatorForm.invalid || isSubmitting">{{'businessTexts.send' |
                        translate}}
                    </button>
                </div>
            </form>

        </div>

    </mat-card-content>
</mat-card>
-->